import axios from 'axios';
import { noop } from 'lodash/fp';
import config from '../../helpers/config';
import withCancellation from '../withCancellation';

const repId = (config.repId || noop)();

const instance = axios.create({
  baseURL: config.designBuilderApiBaseUrl,
  headers: {
    'x-api-key': config.designBuilderApiKey,
    'x-repid': repId || '',
  },
});

export default withCancellation(instance);
